export const nowSeconds = () => Math.floor(Date.now() / 1000)
